exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".component---RbsQm {\n  background-color: #fff;\n  width: 100%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  padding-bottom: 16px;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  -webkit-box-align: end;\n      -ms-flex-align: end;\n          align-items: flex-end; }\n  .component---RbsQm .export-btn---2ZY-u {\n    margin-left: 5px;\n    font-size: 14px;\n    padding: 6px 20px; }\n  .component---RbsQm .download-btn---3tNR- {\n    margin-left: 5px;\n    font-size: 14px;\n    padding: 6px 20px; }\n", ""]);

// exports
exports.locals = {
	"component": "component---RbsQm",
	"export-btn": "export-btn---2ZY-u",
	"download-btn": "download-btn---3tNR-"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[local]---[hash:base64:5]!./~/postcss-loader/lib!./~/sass-loader!./components/sub-heading/sub-heading.scss
// module id = hyqk
// module chunks = 1